<template>
    <div class="centerPage">
        <div class="search flex">
            <span class="tit">测试分析</span>
            <router-link to="/doctor/test/list/old" class="flex">
                <img src="../../assets/img/set.png" alt="" width="17">
                历史分析
            </router-link>
        </div>
        <div class="border">
            <div class="flex searchTab">
                <el-radio-group v-model="condition.examType" size="small" @change="getData">
                    <el-radio-button
                            v-for="obj in types"
                            :key="obj.id"
                            :label="obj.id">
                        {{obj.itemName}}
                    </el-radio-button>
                </el-radio-group>
            </div>
            <el-table
                    @sort-change="sortChange"
                    v-if="data!=0"
                    class="record-table"
                    :data="data"
                    :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                    height="calc(100vh - 400px)">
                <el-table-column label="测试单号" prop="resultNo" align="center" width="160"></el-table-column>
                <el-table-column label="测试名称" prop="title" align="center"></el-table-column>
                <el-table-column label="测试类型" prop="itemName" align="center"></el-table-column>
                <el-table-column
                        label="测试时间"
                        align="center"
                        prop="examDate"
                        :sort-orders="['ascending', 'descending']"
                        sortable></el-table-column>
                <el-table-column
                        prop="expense"
                        sortable
                        label="支付金额(元)"
                        align="center"
                        width="150">
                    <template slot-scope="scope">
                        <span class="disabled">{{scope.row.expense}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" class="detail"
                                   @click="$router.push({name:'doctorTestDetail',query:{no: scope.row.resultNo}})">去分析
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="empty" v-else>
                <img src="../../assets/img/no.png" alt="" width="200">
                <p>这里什么都没有</p>
            </div>
            <el-pagination
                    class="pagination"
                    background
                    prev-text="Prev"
                    next-text="Next"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.current"
                    :page-size="page.size"
                    layout="prev, pager, next"
                    :total="page.total">
            </el-pagination>
        </div>


    </div>
</template>

<script>
    import commonjs from "../../api/common";

    export default {
        name: "testListNew",
        data() {
            return {
                types: [{
                    id: 0,
                    itemName: '所有',
                    list: []
                }],
                page: {
                    current: 1,
                    size: 10,
                    total: 20,
                    type: 0,
                    index: 0,
                },
                condition: {
                    examType: 0,
                    orderByDate: '',
                    orderByExpense: ''
                },//条件
                data: [],
            }
        },
        mounted() {
            this.$ajax.get(commonjs.api.dict.exam.type).then((res) => {
                if (res.data.status === 'success') {
                    this.types = this.types.concat(res.data.list);
                }
            });
            this.getData();
        },
        methods: {
            getData() {
                let that = this;
                this.$ajax
                    .post(commonjs.api.exam.doctor.newPage.replace("{current}/{size}", this.page.current + "/" + this.page.size), this.condition)
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.data = res.data.rows;
                        that.page.total = res.data.total;
                      }
                    })
            },
            handleSizeChange(val) {
                this.page.size = val;
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getData();
            },
            sortChange(val) {
                if (val.prop === 'examDate') {
                    if (val.order === 'ascending') {
                        this.condition.orderByDate = 'ASC'
                    } else if (val.order === 'descending') {
                        this.condition.orderByDate = 'DESC'
                    } else {
                        this.condition.orderByDate = ''
                    }
                }
                if (val.prop === 'expense') {
                    if (val.order === 'ascending') {
                        this.condition.orderByExpense = 'ASC'
                    } else if (val.order === 'descending') {
                        this.condition.orderByExpense = 'DESC'
                    } else {
                        this.condition.orderByExpense = ''
                    }
                }
                // if(column.prop == null || column.order == null){
                //     this.queryData.prop = "";
                //     this.queryData.order = "";
                // }else{
                //     this.queryData.prop = column.prop;
                //     this.queryData.order = column.order;
                // }
                // this.getList();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/patients.scss';
    @import "../../assets/css/personalCenter.scss";

    .centerPage {
        display: block;
    }

    .search a {
        color: #567BFF;
        font-size: 13px;
    }

    .detail {
        border-color: #567BFF;
        color: #567BFF;
        background: #ffffff;

        &:hover, &:focus {
            color: #567BFF;
            border-color: #567BFF;
            background-color: #ffffff;
        }
    }
</style>